import {type SoftDeletable, type TimeStamped} from "./common";
import {CompanyMember} from "./companyMember";
import {type LanguageType} from "./languageType";
import {type MeasureSystemType} from "./measureSystemType";
import {DateFormatType} from "./dateFormat";

export enum UserGlobalRole {
    USER = "USER",
    HYDROSAT = "HYDROSAT",
    CS = "CS",
    ADMIN = "ADMIN",
}

export interface UserProperties {
    email: string;
    firstName: string;
    lastName: string;
    company: string | null;
    country: string | null;
    phone: string | null;
}

export interface UserPreferences {
    measureSystem?: MeasureSystemType;
    language?: LanguageType;
    enabledMarketingEmails: boolean;
    enabledAdvancedFeatures?: boolean;
    enabledFieldAlerts?: boolean;
    enabledUiHelp?: boolean;
    dateFormat: DateFormatType;
}

export type UserCompanySecurity = Omit<CompanyMember, "userId">;

export type UserSecurityAttributes = Partial<Record<string, boolean>>;

export interface UserSecurity {
    role: UserGlobalRole;
    attributes: UserSecurityAttributes;
}

export interface UserAggregatedProps {
    lastActivity?: Date;
}

export interface User extends TimeStamped, SoftDeletable {
    id: string;
    security: UserSecurity;
    properties: UserProperties;
    preferences: UserPreferences;
    isApiEnabled: boolean;
    isActive: boolean;
    companySecurity: UserCompanySecurity[];
    aggregatedProps: UserAggregatedProps;
}

export interface UserLimitedInfo {
    firstName: string;
    lastName: string;
}
